'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHighlightedMerchIdForEdition = exports.getAdditionalUnitsQuantityMinusIncluded = exports.isAdditionalUnitsMerchIdSameAsBaseMerchId = undefined;

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getBaseProductForAdditionalUnitMerchId = function _getBaseProductForAdditionalUnitMerchId(additionalUnitMerchId) {
  return Object.keys(_ImmutableMerchandiseIdMap2.default).find(function (merchId) {
    return _ImmutableMerchandiseIdMap2.default[merchId].additionalUnitMerchId === additionalUnitMerchId;
  });
};

var isAdditionalUnitsMerchIdSameAsBaseMerchId = exports.isAdditionalUnitsMerchIdSameAsBaseMerchId = function isAdditionalUnitsMerchIdSameAsBaseMerchId(merchId) {
  return merchId === _ImmutableMerchandiseIdMap2.default[merchId].additionalUnitMerchId;
};

var getAdditionalUnitsQuantityMinusIncluded = exports.getAdditionalUnitsQuantityMinusIncluded = function getAdditionalUnitsQuantityMinusIncluded(inputAdditionalUnitsQuantity, additionalUnitsMerchId) {
  var baseProductMerchId = _getBaseProductForAdditionalUnitMerchId(additionalUnitsMerchId);

  if (baseProductMerchId && _ImmutableMerchandiseIdMap2.default[baseProductMerchId].includedAdditionalUnits) {
    return inputAdditionalUnitsQuantity - _ImmutableMerchandiseIdMap2.default[baseProductMerchId].includedAdditionalUnits;
  }
  return inputAdditionalUnitsQuantity;
};

var getHighlightedMerchIdForEdition = exports.getHighlightedMerchIdForEdition = function getHighlightedMerchIdForEdition(hub, edition) {
  var highlightedMerchForHub = _HubMap2.default[hub].highlightedPaidMerch;
  return highlightedMerchForHub.find(function (merchId) {
    return _ImmutableMerchandiseIdMap2.default[merchId].edition === edition;
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/merchUtils.js
// module id = 124
// module chunks = 3 4 5